<script setup>
import { useAppStore } from '../store/app';
const store = useAppStore();
</script>
<template>
  <v-dialog v-model="store.appLoading" persistent :scrim="false" transition="none" width="300">
    <v-card color="primary" dark>
      <v-card-text>
        Loading
        <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
